import React from 'react';
import {
  FDAvatar,
  FDBodyText,
  FDPaper,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import moment from 'moment-timezone';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import Spacer from 'Components/UI/Spacer';

const latestMeetingDateFormat = 'dddd, MMMM Do [@] h:mma z';

const useStyles = buildUseStyles('PlannerInsightChat', ((theme) => ({
  container: {
    position: 'relative', // The positioning context for the absolutely positioned avatar
    '& div.FD-MuiPaper-root': { // target the paper
      backgroundColor: theme.palette.facet.oceana50,
    },
  },
  avatarOnTopLeft: {
    position: 'absolute', // Takes the avatar out of the document flow and positions it
    top: -16, // Adjust this value to control how far up the avatar is
    left: 20, // Adjust this value to control the horizontal position
    zIndex: 1, // Ensures the avatar is on top of the paper
    '& .FD-MuiAvatar-root': { // target the avatar
      border: `6px solid ${theme.palette.facet.lightGray}`, // bone background border around the avatar
    },
    width: '100%',
  },
})));


const NextMeetingScheduleInfo = () => {
  const { resource } = useMetaLayoutContext();
  const theme = useTheme();
  const classes = useStyles(theme);

  if (!resource) {
    return null;
  }


  const PlannerAvatar = resource.withRelationship(
    fr.relationships.plannerProfileImage.name,
    (rel) => <FDAvatar src={rel.link('related')?.url()} alt={rel.meta('altText')} size={'lg'} />,
    () => null,
  );

  return (
    <div className={classes.container}>
      <div className={classes.avatarOnTopLeft}>
        <FDStack direction={'row'} spacing={1}>
          {PlannerAvatar}
          <FDStack alignItems={'flex-end'} direction={'row'} justifyContent={'space-between'} width={'100%'}>
            <MetaControlField attr={'leadPlannerName'} />
          </FDStack>
        </FDStack>
      </div>
      <FDPaper appearance={'outlined'} color={'info'} padding={3} {...dataAttrs('next-meeting-schedule-info')}>
        <FDStack direction={'column'} spacing={5}>
          <Spacer />
          <FDStack direction={'column'}>
            <MetaControlField attr={'nextMeetingTitle'} />
            { resource.attr('nextMeetingDate')
              ? <FDBodyText
                value={moment(resource.attr('nextMeetingDate')).tz(moment.tz.guess()).format(latestMeetingDateFormat)}
                size={'lg'}
              /> : null}
          </FDStack>
        </FDStack>
      </FDPaper>
    </div>
  );
};

export default NextMeetingScheduleInfo;
